import type { QueryClient } from '@tanstack/react-query';

/**
 * A record joined or left the start backlog outside the processing hooks —
 * a retry left it waiting for a start (#1264). Both summaries go stale: the
 * portal's and the Bitrix24 app's, whichever is mounted. Without this the
 * card kept its old count and price, and «Start all» then started the parked
 * record at a price the card never showed.
 */
export function invalidateBacklogSummaries(queryClient: QueryClient): void {
  void queryClient.invalidateQueries({ queryKey: ['records', 'backlog-summary'] });
  void queryClient.invalidateQueries({
    queryKey: ['embedded', 'records', 'backlog-summary'],
  });
}
